
import { format, parseISO, isSameDay as isSameDayFns } from "date-fns";

/**
 * Format a date string into a human-readable format
 */
export const formatDate = (dateString: string): string => {
  try {
    const date = parseISO(dateString);
    return format(date, "MMMM d, yyyy");
  } catch (error) {
    console.error("Error formatting date:", error);
    return dateString;
  }
};

/**
 * Format a date to ISO format with timezone for API requests
 */
export const formatDateForApi = (date: Date): string => {
  return format(date, "yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXX");
};

/**
 * Check if two dates are the same day
 */
export const isSameDay = (date1: Date, date2: Date): boolean => {
  return isSameDayFns(date1, date2);
};

/**
 * Determines if a date is present in an array of dates (checking only the day, month, and year)
 */
export const isDateInArray = (date: Date, dateArray: Date[]): boolean => {
  return dateArray.some(d => isSameDay(date, d));
};
